import { AbstractControl, AbstractControlOptions, ValidationErrors, ValidatorFn } from '@angular/forms';

import { EditorBookingItemSetting } from './editor-booking-item-setting.model';
import { EditorDataService } from '../editor-data/editor-data.service';


const settingValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  if (control.pristine) {
    return null;
  }

  return control.get('price').value !== null
      && control.get('currency').value !== null
      && control.get('methods').value.length > 0
    ? null
    : { invalidPricing: true };
};


export class EditorBookingItemSettingPricing extends EditorBookingItemSetting {
  settingClassName = 'Pricing';
  serializedName = 'pricing';
  showSummary = true;

  price: number;
  currency: string;
  methods: string[];

  constructor(obj?: any) {
    super({
      inheritableType: obj?.inheritableType ?? null
    });
    this.price = obj?.price ?? null;
    this.currency = obj?.currency ?? null;
    this.methods = obj?.methods ?? [];
  }

  createCopy(): EditorBookingItemSettingPricing {
    return new EditorBookingItemSettingPricing({
      price: this.price,
      currency: this.currency,
      methods: [...this.methods],
      inheritableType: this.inheritableType
    });
  }

  getTitle(): string {
    return $localize `Pricing`;
  }

  getHelpText(): string {
    return $localize `Please enter the currency, price and accepted payment method(s)`;
  }

  hasSummary(): boolean {
    return this.price !== null || this.currency !== null || this.methods.length > 0;
  }

  getCurrencyName(currencyNames: { id: string, name: string }[]): string {
    if (this.currency === null) { return ''; }
    return currencyNames
      .find(currencyName => currencyName.id === this.currency)?.name ?? $localize `Not valid`;
  }

  getMethodsAsString(paymentMethodNames: { id: string, name: string }[]): string {
    if (this.methods.length === 0) { return ''; }
    return this.methods
      .map(method =>
        paymentMethodNames.find(paymentMethodName => paymentMethodName.id === method) ?? { id: method, name: $localize `Not valid` }
      )
      .map(paymentMethodName => paymentMethodName.name)
      .join(', ');
  }

  getFormConfig(_editorData: EditorDataService): {
    controlsConfig: { [key: string]: any; },
    options?: AbstractControlOptions
  } {
    return {
      controlsConfig: {
        price: [this.price],
        currency: [this.currency],
        methods: [this.methods]
      },
      options: {
        validators: settingValidator
      }
    };
  }

  getFormValues(): any {
    return {
      price: this.price,
      currency: this.currency,
      methods: this.methods
    };
  }

  getEmptyFormValues(): any {
    return {
      price: null,
      currency: null,
      methods: []
    };
  }

  applyFormValues(formValues: any) {
    this.price = formValues.price;
    this.currency = formValues.currency;
    this.methods = formValues.methods;
  }

  getSerializedValues(): any {
    return {
      price: this.price,
      currency: this.currency,
      method: this.methods
    };
  }
}
